import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import "./index.css";
import HomePage from "./pages/HomePage";
import ServiceWebPage from "./pages/ServiceWebPage";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import EmpecemosPage from "./pages/EmpecemosPage";
import { LeadProvider } from "./context/LeadContext"; // <-- nuevo

const theme = createTheme({
  palette: {
    primary: {
      main: "#f35a3a",
    },
    secondary: {
      main: "#27AE60",
    },
    terciary: {
      main: "#2C3E50",
    },

    success: {
      main: "#018E42",
    },
    white: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
  },
  breakpoints: {
    values: {
      xs: 0, // Extra small (teléfonos pequeños)
      sm: 600, // Small (teléfonos y tablets en orientación vertical)
      md: 960, // Medium (tablets en orientación horizontal y algunos dispositivos en orientación vertical)
      lg: 1280, // Large (pantallas de escritorio y algunos dispositivos en orientación horizontal)
      xl: 1920, // Extra large (pantallas grandes y extra grandes)
    },
  },

  // Aplica el fondo en el tema
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          backgroundColor: "#2C3E50",
        },
      },
    },
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>
      <LeadProvider>   {/* ⬅️ envuelve TODO para que esté disponible en cualquier página */}
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/servicios" element={<ServiceWebPage />} />
            <Route path="/empecemos" element={<EmpecemosPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </LeadProvider>
    </ThemeProvider>
  );
}


export default App;
